var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { buildDemoSummaryTeamAverageDiff, buildDemoSummaryTeamAverageSecondsDiff } from '@web/lib/demo/utils';
import { diffComparisonValueFormat } from '@workalizer/shared/types';
import { getPercentageDiff, randomInt } from '@workalizer/shared/utils';
var buildCountMetric = function (count, previousCount, includeTeamAverage) {
    if (includeTeamAverage === void 0) { includeTeamAverage = false; }
    return (__assign({ count: count, previous: getPercentageDiff(previousCount, count) }, (includeTeamAverage
        ? { teamAverage: buildDemoSummaryTeamAverageDiff(count) }
        : {})));
};
var buildSecondsMetric = function (seconds, previousSeconds, includeTeamAverage) {
    if (includeTeamAverage === void 0) { includeTeamAverage = false; }
    return (__assign({ seconds: seconds, previous: getPercentageDiff(previousSeconds, seconds, {
            comparisonValueFormat: diffComparisonValueFormat.durationSeconds
        }) }, (includeTeamAverage
        ? { teamAverage: buildDemoSummaryTeamAverageSecondsDiff(seconds) }
        : {})));
};
var buildShareMetric = function (share, previousShare) { return ({
    share: share,
    previous: getPercentageDiff(previousShare, share)
}); };
export var meetSummary = function (input) {
    var includeTeamAverage = input.userId != null;
    var includeManHours = input.userId == null;
    var meetingsAttended = randomInt(80, 200);
    var previousMeetingsAttended = randomInt(60, 160);
    var durationSeconds = randomInt(20, 60) * 3600;
    var previousDurationSeconds = randomInt(15, 50) * 3600;
    var manHoursSeconds = durationSeconds * randomInt(3, 8);
    var previousManHoursSeconds = previousDurationSeconds * randomInt(3, 8);
    var oneToOneShare = randomInt(35, 55);
    var previousOneToOneShare = randomInt(30, 50);
    var internalShare = randomInt(65, 85);
    var previousInternalShare = randomInt(60, 80);
    var recurringShare = randomInt(45, 65);
    var previousRecurringShare = randomInt(40, 60);
    var response = __assign(__assign({ meetingsAttended: buildCountMetric(meetingsAttended, previousMeetingsAttended, includeTeamAverage), totalDuration: buildSecondsMetric(durationSeconds, previousDurationSeconds, includeTeamAverage) }, (includeManHours
        ? {
            manHours: buildSecondsMetric(manHoursSeconds, previousManHoursSeconds, includeTeamAverage)
        }
        : {})), { oneToOneVsGroup: {
            left: buildShareMetric(oneToOneShare, previousOneToOneShare),
            right: buildShareMetric(100 - oneToOneShare, 100 - previousOneToOneShare)
        }, internalVsExternal: {
            left: buildShareMetric(internalShare, previousInternalShare),
            right: buildShareMetric(100 - internalShare, 100 - previousInternalShare)
        }, recurringVsAdhoc: {
            left: buildShareMetric(recurringShare, previousRecurringShare),
            right: buildShareMetric(100 - recurringShare, 100 - previousRecurringShare)
        } });
    return response;
};
